import clsx from "clsx";
import { DraggableWord } from "../DraggableWord";
import { Droppable } from "../Droppable";
import { Word } from "../Word";
import classes from './DropzoneBlank.module.scss';
import { useEffect, useImperativeHandle, useState } from "react";
import { useAnimate } from "framer-motion";
import { COMPLETAR_SOUNDS } from "../../utils/constants";
import { useGameSounds } from "@educaplay/core";

const FOCUS_DELAY = 250;

export const DropzoneBlank = (props) => {
    const { blankId, gameState, clickBlankHandler, clickWordHandler, activeId, ref } = props;

    const blank = gameState.idBlanks.find(blank => blank.id === blankId);
    const [wordRef, animateWord] = useAnimate();    
    const [animationStatus, setAnimationStatus] = useState(null);

    const gameSounds = useGameSounds();

    useImperativeHandle(ref, () => ({
        success: async () => {
            wordRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            gameSounds.play(COMPLETAR_SOUNDS.CORRECT);
            setAnimationStatus('success');
            await animateWord(wordRef.current, { y: [-20, 0] }, {  duration: .4 });
        },
        fail: async () => {
            wordRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            gameSounds.play(COMPLETAR_SOUNDS.WRONG);
            setAnimationStatus('fail');
            await animateWord(wordRef.current, { y: [-20, 0] }, {  duration: .4 });
        },
        empty: async () => {
            wordRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            setAnimationStatus(null);
            await animateWord(wordRef.current, { x: [-20, 18, -10, 4, 0] }, { duration: .3 });
        },
        focus: ({hasDelay}) => {
            const delay = hasDelay ? FOCUS_DELAY : 0;
            setTimeout(() => {
                wordRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }, delay);
        }
    }));
    
    useEffect(() => {
        setAnimationStatus(null);
    }, [gameState]);

    if (!blank) return null;
    
    const clickHandler = () => {
        clickBlankHandler(blank.id);
        wordRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    const word = blank.fill ? gameState.words.find(word => word.id === blank.fill) : null;
    
    const isFilled = blank.fill || animationStatus === 'success' || animationStatus === 'fail';
    const isCorrect = blank.isCorrect || animationStatus === 'success';
    const isWrong = (blank.isCorrect !== null && !blank.isCorrect) || animationStatus === 'fail';

    return (
        <Droppable id={blank.id} className={classes.flex} onClick={() => clickHandler()} >
            <div ref={wordRef}
                className={clsx(
                    classes.blank,
                    isFilled && classes['blank--fill'],
                    isCorrect && classes['blank--correct'], 
                    isWrong && classes['blank--wrong'],
                    blank.id === activeId && classes['blank--active']
                )}
                onMouseEnter={() => gameSounds.play(COMPLETAR_SOUNDS.HOVER)}
            >
                {isFilled && !isCorrect && <DraggableWord word={word} styles={{wrong: isWrong}} place={'text'} onClick={() => clickWordHandler(word.id)} origin={`text_${blankId}`} animationStatus={animationStatus} />}
                {isCorrect && <Word word={word} styles={{correct: true}} place={'text'} mode={'dnd'} animationStatus={animationStatus} />}
            </div>
        </Droppable>
    )
}